import { render, staticRenderFns } from "./ViewReply.vue?vue&type=template&id=8d60a0a6&scoped=true"
import script from "./ViewReply.vue?vue&type=script&lang=js"
export * from "./ViewReply.vue?vue&type=script&lang=js"
import style0 from "./ViewReply.vue?vue&type=style&index=0&id=8d60a0a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d60a0a6",
  null
  
)

export default component.exports